<h2 class="section-title">{{ 'components.settingsForm.entitySection.edit.title' | translate }}</h2>
<form [formGroup]="entityForm" (ngSubmit)="save()">
    <div class="card form-grid form-grid--2">
        <div class="form-field">
            <label for="nameInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.entitySection.edit.name.label' | translate }}
            </label>
            <input
                id="nameInput"
                pInputText
                type="text"
                formControlName="name"
                [placeholder]="'components.settingsForm.entitySection.edit.name.placeholder' | translate" />
            @if (entityForm.controls.name.errors?.required && entityForm.controls.name.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="fteInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.entitySection.edit.fte.label' | translate }}
            </label>
            <p-inputNumber
                inputId="fteInput"
                formControlName="fte"
                [min]="1"
                [placeholder]="
                    'components.settingsForm.entitySection.edit.fte.placeholder' | translate
                "></p-inputNumber>
            @if (entityForm.controls.fte.invalid && entityForm.controls.fte.touched) {
                @if (entityForm.controls.fte.errors?.required) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
                @if (entityForm.controls.fte.errors?.min) {
                    <small class="p-error">{{
                        'common.forms.validationMessages.min'
                            | translate: { min: entityForm.controls.fte.errors?.min?.min }
                    }}</small>
                }
            }
        </div>
        <div class="form-field">
            <label for="countryInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.entitySection.edit.country.label' | translate }}
            </label>
            <p-select
                inputId="countryInput"
                [options]="countries"
                formControlName="country"
                [placeholder]="'components.settingsForm.entitySection.edit.country.placeholder' | translate"
                [filter]="true"
                filterMatchMode="startsWith"
                optionLabel="name"
                optionValue="code"
                [emptyFilterMessage]="'common.filter.empty' | translate"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                (onBlur)="filterCities()"
                [filterPlaceholder]="'common.search' | translate">
            </p-select>
            @if (entityForm.controls.country.errors?.required && entityForm.controls.country.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="cityInput" class="form-field__label">
                {{ 'components.settingsForm.entitySection.edit.city.label' | translate }}
            </label>
            <p-select
                inputId="cityInput"
                [options]="filteredCities"
                formControlName="city"
                [placeholder]="'components.settingsForm.entitySection.edit.city.placeholder' | translate"
                [filter]="true"
                filterMatchMode="startsWith"
                optionLabel="name"
                optionValue="id"
                [emptyFilterMessage]="'common.filter.empty' | translate"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                [filterPlaceholder]="'common.search' | translate">
            </p-select>
        </div>
        <div class="form-field form-field--wide">
            <label for="industryInput" class="form-field__label">
                {{ 'components.settingsForm.entitySection.edit.industry.label' | translate }}
            </label>
            <p-select
                inputId="industryInput"
                [options]="industries"
                formControlName="industry"
                [placeholder]="'components.settingsForm.entitySection.edit.industry.placeholder' | translate"
                [filter]="true"
                filterMatchMode="startsWith"
                optionLabel="label"
                optionValue="industrySectorId"
                [emptyFilterMessage]="'common.filter.empty' | translate"
                [virtualScroll]="true"
                [virtualScrollItemSize]="27"
                [filterPlaceholder]="'common.search' | translate">
            </p-select>
        </div>
        @if (false) {
            <div class="form-field">
                <label for="growthInput" class="form-field__label">
                    {{ 'components.settingsForm.entitySection.edit.growth.label' | translate }}
                </label>
                <p-inputgroup>
                    <input id="growthInput" pInputText type="text" formControlName="growth" pKeyFilter="num" />
                    <p-inputgroup-addon> % </p-inputgroup-addon>
                </p-inputgroup>
            </div>
        }
        <div class="form-field">
            <label for="currencyInput" class="form-field__label form-field__label--required">
                {{ 'components.settingsForm.entitySection.edit.currency.label' | translate }}
            </label>
            <p-select
                inputId="currencyInput"
                [options]="currencyOptions"
                formControlName="currency"
                optionLabel="label"
                optionValue="code"
                [placeholder]="'components.settingsForm.entitySection.edit.currency.placeholder' | translate">
            </p-select>
            @if (entityForm.controls.currency.errors?.required && entityForm.controls.currency.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="revenuesInput" class="form-field__label">
                {{ 'components.settingsForm.entitySection.edit.revenues.label' | translate }}
            </label>
            <p-inputgroup>
                <p-inputNumber
                    inputId="revenuesInput"
                    formControlName="revenues"
                    [min]="0"
                    [placeholder]="'components.settingsForm.entitySection.edit.revenues.placeholder' | translate" />
                @if (entityForm.controls.currency.value) {
                    <p-inputgroup-addon>
                        {{ 'unit.' + entityForm.controls.currency.value | translate }}
                    </p-inputgroup-addon>
                }
            </p-inputgroup>
            @if (entityForm.controls.revenues.errors?.min && entityForm.controls.revenues.touched) {
                <small class="p-error">{{
                    'common.forms.validationMessages.min'
                        | translate: { min: entityForm.controls.revenues.errors?.min?.min }
                }}</small>
            }
        </div>
        <div class="form-field form-field--wide">
            <label for="commentInput" class="form-field__label">
                {{ 'components.settingsForm.entitySection.edit.comment.label' | translate }}
            </label>
            @if (entity?.commentUserName && entity?.commentUpdatedAt) {
                <div class="form-field__help flex align-items-center gap-3">
                    <span class="flex align-items-center gap-1">
                        <span class="material-symbols-outlined icon-sm" aria-hidden="true">person</span>
                        {{ entity?.commentUserName }}
                    </span>
                    <span class="flex align-items-center gap-1">
                        <span class="material-symbols-outlined icon-sm" aria-hidden="true">schedule</span>
                        {{ formatCommentDate(entity?.commentUpdatedAt) }}
                    </span>
                </div>
            }
            <textarea
                id="commentInput"
                pTextarea
                formControlName="comment"
                [maxlength]="5000"
                [rows]="3"
                [placeholder]="'components.settingsForm.entitySection.edit.comment.placeholder' | translate">
            </textarea>
        </div>
    </div>

    <!-- KPI denominators of an existing entity, per year with carbon data. -->
    @if (entity?.id && availableYears.length > 0) {
        <h2 class="section-title mt-5 mb-1">{{ 'components.settingsForm.entitySection.kpi.title' | translate }}</h2>
        <p class="section-description">
            {{ 'components.settingsForm.entitySection.kpi.description' | translate }}
        </p>
        <div class="card">
            @if (kpiTypes.length > 0) {
                <app-kpi-denominator-matrix
                    [types]="kpiTypes"
                    [years]="availableYears"
                    [values]="entityKpiDenominators"
                    (cellsChange)="onKpiCellsChange($event)"></app-kpi-denominator-matrix>
            } @else {
                <div class="empty-state empty-state--compact">
                    <p class="empty-state__text">
                        {{ 'components.settingsForm.entitySection.kpi.noTypes' | translate }}
                    </p>
                </div>
            }
        </div>
    }
    <div class="form-actions">
        @if (entity && undeletedEntities.length > 1) {
            <p-button
                class="form-actions__start"
                severity="danger"
                [text]="true"
                icon="ms ms-delete"
                [label]="'components.settingsForm.button.remove' | translate"
                (onClick)="onDelete()" />
        }
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="close()" />
        <p-button type="submit" [label]="'common.confirm_button' | translate" />
    </div>
</form>
<p-confirmDialog />
